export default "__VITE_ASSET__O2mXuGTM__"